import { IWCEthRpcConnectionOptions } from '@binance/w3w-types'
import type { WalletInit } from '@web3-onboard/common'

function binanceW3W({
  options,
}: {
  options?: IWCEthRpcConnectionOptions
} = {}): WalletInit {
  return () => {
    return {
      label: 'Binance',
      getIcon: async () => (await import('./icon.js')).default,
      getInterface: async ({ chains }) => {
        const [chain] = chains

        const config: IWCEthRpcConnectionOptions = {
          ...options,
          chainId: Number(chain.id),
          rpc: chains
            .map(({ id, rpcUrl }) => ({ id, rpcUrl }))
            .reduce((rpcMap: Record<number, string>, { id, rpcUrl }) => {
              rpcMap[parseInt(id, 16)] = rpcUrl || ''
              return rpcMap
            }, {}),
        }
        const { getProvider } = await import('@binance/w3w-ethereum-provider')

        const binanceW3WProvider = getProvider(config)
        return {
          provider: binanceW3WProvider,
        }
      },
    }
  }
}

export default binanceW3W
